import * as React from "react";
const SvgSignalCellularNull = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6.83V20H6.83L20 6.83M22 2 2 22h20V2z",
  fill: "currentColor"
}));
export default SvgSignalCellularNull;